<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { dynamicTime } from 'shared/helpers/timeHelper';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  note: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['delete']);

const { t } = useI18n();

const authorName = computed(
  () => props.note.user?.name || t('PROJECTS.NOTES.UNKNOWN_AUTHOR')
);
const timeAgo = computed(() => dynamicTime(props.note.created_at));
</script>

<template>
  <div class="flex flex-col gap-1.5 py-2.5 group">
    <div class="flex items-center gap-2">
      <Avatar :name="authorName" :src="note.user?.thumbnail" :size="20" />
      <span class="text-xs font-medium text-n-slate-12">{{ authorName }}</span>
      <span class="text-xs text-n-slate-10">{{ timeAgo }}</span>
      <Button
        v-tooltip.top="t('PROJECTS.NOTES.DELETE')"
        variant="ghost"
        color="ruby"
        size="xs"
        icon="i-lucide-trash-2"
        class="ml-auto transition-opacity opacity-0 group-hover:opacity-100"
        @click="emit('delete', note.id)"
      />
    </div>
    <p class="text-sm whitespace-pre-line text-n-slate-12">
      {{ note.content }}
    </p>
  </div>
</template>
